import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLinkedinFilled = (_a) => {
  var _b = _a, { size, title = "LinkedinFilled" } = _b, props = __objRest(_b, ["size", "title"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    "data-icon-name": title,
    "aria-label": title,
    role: "presentation"
  }, props), /* @__PURE__ */ React.createElement("path", {
    fill: "currentColor",
    d: "M8.155 19H5.197v-8.842h2.958V19zM6.676 8.438a1.73 1.73 0 01-1.558-1.095 1.714 1.714 0 01.405-1.856A1.727 1.727 0 018.45 6.719a1.746 1.746 0 01-.532 1.224c-.332.322-.78.5-1.243.495zM19 19h-2.958v-4.657c0-1.395-.591-1.896-1.36-1.896a1.718 1.718 0 00-1.513 1.163c-.072.214-.1.44-.085.664a.646.646 0 000 .138V19h-2.957v-8.842h2.859v1.277a3.062 3.062 0 012.662-1.376c1.528 0 3.313.845 3.313 3.596L19 19z"
  }));
};
var LinkedinFilled = withIcon(SvgLinkedinFilled);

export { LinkedinFilled as default };
//# sourceMappingURL=LinkedinFilled.es.js.map
